import http from '../../http-common';
import httpStudents from '../../http-common-students';

    export const getAllNotifications = (universityID, usuarioID, tipoPesquisa, replayMainID) =>{
        return http.get(`/notificacoesUsuario?universityID=${universityID}&usuarioID=${usuarioID}&tipoPesquisa=${tipoPesquisa}&replayMainID=${replayMainID}`);
    }
    
    export const getAllNotificationsGetReplyID = (universityID, usuarioID, tipoPesquisa) =>{
        return http.get(`/notificacoesUsuario?universityID=${universityID}&usuarioID=${usuarioID}&tipoPesquisa=${tipoPesquisa}`);
    }
    export const getcodeNotification = (id, tipoPedido, sedeID, usuarioID) =>{
        return http.get(`/notificacoesUsuario/${id}?tipoPedido=${tipoPedido}&sedeID=${sedeID}&usuarioID=${usuarioID}`)
    }

    export const createNotification = (data) =>{
        return  http.post("/notificacoesUsuario", data);
    }

    export const createNotificationStudent = (data) =>{
        return  httpStudents.post("/notificacoesUsuario", data);
    }
    // Search denuncias ID
    export const getIDNotification = (id) =>{
        return http.get(`/notificacoesUsuario/${id}`)
    }

    export const updateNotification = (id, data) =>{
        return http.put(`/notificacoesUsuario/${id}`, data)
    }
    export const updateNotificacaoLida = (id, respostaMensagem, idNotificacaoOriginal) =>{
        return http.put(`/notificacoesUsuario/${id}?respostaMensagem=${respostaMensagem}&idNotificacaoOriginal=${idNotificacaoOriginal}`)
    }

    export const deleteNotification = (id) =>{
        return http.delete(`/notificacoesUsuario/${id}`)
    }

    export const  getAllNotificacaoRecus = (tipoPesquisa, universityID, usuarioID, typeMessage) => {
        return  http.get(`/notificacoesUsuario?tipoPesquisa=${tipoPesquisa}&universityID=${universityID}&usuarioID=${usuarioID}&typeMessage=${typeMessage} `)
    }

    export const  getAllMensagemenvoyes = (tipoPesquisa, universityID, usuarioID, typeMessage, date1, date2) => {
        return  http.get(`/notificacoesUsuario?tipoPesquisa=${tipoPesquisa}&universityID=${universityID}&usuarioID=${usuarioID}&typeMessage=${typeMessage}&date1=${date1}&date2=${date2} `)
    }

    export const  getAllMensagemenvoyesByMainID = (tipoPesquisa, mainID) => {
        
        return  http.get(`/notificacoesUsuario?tipoPesquisa=${tipoPesquisa}&mainID=${mainID}`)
            
    }

    export const  getAllNotificacaoRecusStudents = (tipoPesquisa, universityID, studentMatriculaID, typeMessage, date1, date2) => {
        
        return  http.get(`/notificacoesUsuario?tipoPesquisa=${tipoPesquisa}&universityID=${universityID}&studentMatriculaID=${studentMatriculaID}&typeMessage=${typeMessage}&date1=${date1}&date2=${date2} `)    
    }

    export const updateNotificationEtudiant = (id, data) =>{
        return httpStudents.put(`/notificacoesUsuario/${id}`, data)
    }

    export const getMessagemNaoLidaStudents = (tipoPesquisa, universityID, studentMatriculaID) =>{
        return  httpStudents.get(`/notificacoesUsuario?tipoPesquisa=${tipoPesquisa}&universityID=${universityID}&studentMatriculaID=${studentMatriculaID} `)    

    }

    export const getMessagemNaoLidaAdministrators = (tipoPesquisa, userID) =>{
        return  http.get(`/notificacoesUsuario?tipoPesquisa=${tipoPesquisa}&userID=${userID}`)    
    }

    export const  getallMessageRecu = (tipoPesquisa, universityID, usuarioID, typeMessage, date1, date2) => {
                
        return  http.get(`/notificacoesUsuario?tipoPesquisa=${tipoPesquisa}&universityID=${universityID}&usuarioID=${usuarioID}&typeMessage=${typeMessage}&date1=${date1}&date2=${date2} `)  
    }

    export const notificationMainDelete = (id, data) =>{
    
        return http.put(`/notificacoesUsuario/updateMessagesId/${id}`, data)
    }